"use client";

import { c as _c } from "react/compiler-runtime";
import { useCart } from "@/queries/useCart";
import { CartErrorState } from "./CartErrorState";
import { CartItemList } from "./CartItemList";
import { CartSkeleton } from "./CartSkeleton";
import { EmptyCart } from "./EmptyCart";
interface Props {
  trustSignalsSlot?: React.ReactNode;
  optionalAddOnsSlot?: React.ReactNode;
}
export function CartBody(t0) {
  const $ = _c(8);
  const {
    trustSignalsSlot,
    optionalAddOnsSlot
  } = t0;
  const {
    data: cart,
    isPending,
    isError,
    refetch
  } = useCart();
  if (isPending) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CartSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (isError) {
    let t1;
    if ($[1] !== refetch) {
      t1 = <CartErrorState onRetry={() => refetch()} />;
      $[1] = refetch;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (!cart?.items?.length) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyCart />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CartItemList />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== optionalAddOnsSlot || $[6] !== trustSignalsSlot) {
    t2 = <div className="flex-1 overflow-y-auto pb-12">{t1}{optionalAddOnsSlot}{trustSignalsSlot}</div>;
    $[5] = optionalAddOnsSlot;
    $[6] = trustSignalsSlot;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}